import { Link } from 'react-router-dom';
import React, { useState, useEffect, useContext } from 'react';
import logo from '../../assets/images/bluesky-vue-logo.png';
import classnames from 'classnames';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import { login as authLogin } from '../../services';
import { AppContext } from '../../AppContext';

var { version: appVersion } = require('../../../package.json');
// import PropTypes from "prop-types";

const SHOULD_REMEMBER_USER_KEY = 'SHOULD_REMEMBER_USER_KEY';
const STORED_USERNAME_KEY = 'STORED_USERNAME_KEY';

export const Login = props => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginLoading, setLoginLoading] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [shouldRememberUser, setShouldRememberUser] = useState(
    JSON.parse(localStorage.getItem(SHOULD_REMEMBER_USER_KEY)),
  );

  const { state, dispatch } = useContext(AppContext);

  const attemptLogin = async (evt, username, password) => {
    evt.preventDefault();
    setLoginError('');
    setLoginLoading(true);
    try {
      const result = await authLogin(username, password);
      
      // Check if MFA is required
      if (result.requiresMfa) {
        localStorage.setItem(SHOULD_REMEMBER_USER_KEY, shouldRememberUser);
        sessionStorage.setItem('mfaTempToken', result.tempToken);
        
        setLoginLoading(false);
        props.history.push('/login/mfa-verify');
        return;
      }

      // Normal login flow (no MFA required)
      localStorage.setItem(SHOULD_REMEMBER_USER_KEY, shouldRememberUser);
      localStorage.setItem(STORED_USERNAME_KEY, username);

      dispatch({
        type: 'UPDATE_ROLES',
        //result will be roles if not a 202 or error
        result,
      });

      setLoginLoading(false);
      window.location = '/';
    } catch (error) {
      console.log(error);
      setLoginLoading(false);
      setLoginError('Invalid username/password combo... Please try again');
    }
  };

  useEffect(() => {
    // check if the user should be remembered and filled
    // const shouldRemember = JSON.parse(localStorage.getItem(SHOULD_REMEMBER_USER_KEY));
    if (shouldRememberUser) {
      const storedUsername = localStorage.getItem(STORED_USERNAME_KEY);
      setUsername(storedUsername);
      setPassword('');
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(SHOULD_REMEMBER_USER_KEY, shouldRememberUser);
  }, [shouldRememberUser]);

  return (
    <div className={classnames('app', 'login-background', 'col-center-center')}>
      <div className={classnames('login-card')}>
        <div className={classnames('login-card-left', 'col-center-center')}>
          <img src={logo} alt={'BlueSky Vue Logo'} style={{ maxWidth: '100%', height: 'auto' }} />
        </div>
        <div className={classnames('login-card-right', 'col-center-center')}>
          <div
            style={{
              marginBottom: 10,
              fontWeight: 'bold',
              fontSize: 28,
              color: 'var(--jmi-blue)',
            }}
          >
            SIGN IN
          </div>
          <form id="login-form" style={{ width: '90%' }} onSubmit={evt => attemptLogin(evt, username, password)}>
            <div className="col-start-start">
              <label>User Name</label>
              <TextField
                value={username}
                margin="dense"
                variant="outlined"
                inputProps={{ 'aria-label': 'bare' }}
                style={{ width: '100%' }}
                onChange={evt => setUsername(evt.target.value)}
              />
            </div>
            <div className={classnames('col-start-start')} style={{ marginTop: 20 }}>
              <div className="row-between-center" style={{ width: '100%' }}>
                <label>Password</label>
                <Link className="forgot-password-label" to={`/login/forgot-password`}>
                  Forget Your Password?
                </Link>
              </div>
              <TextField
                value={password}
                type="password"
                margin="dense"
                variant="outlined"
                inputProps={{ 'aria-label': 'bare' }}
                style={{ width: '100%' }}
                onChange={evt => setPassword(evt.target.value)}
              />
            </div>

            <div style={{ marginTop: 20 }} className={classnames('row-between-center', 'full-width')}>
              <div className={classnames('row-end-center')} onClick={() => setShouldRememberUser(!shouldRememberUser)}>
                <Checkbox style={{ color: '#315382' }} checked={shouldRememberUser} />
                <label>Remember Me</label>
              </div>
              <button type="submit" className="login-submit-button">
                Sign In
              </button>
            </div>
          </form>

          <div className="login-card-submit-details">
            {loginError && <div className="login-card-error">{loginError}</div>}
            {loginLoading && <LinearProgress className="login-card-loading" />}
          </div>
        </div>
      </div>
      <div style={{ marginTop: 25, color: '#aaa', fontSize: 14 }}>Version {appVersion}</div>
    </div>
  );
};

Login.propTypes = {};
